module.exports = __webpack_public_path__ + "img/customer-active-subnav.951c9565.svg";